import React, { useEffect, useState } from 'react';
import CustomColumnChart from '../../../shared/charts/custom-column-chart/CustomColumnChart';
import StatisticsItemList from '../statistics-item-list/StatisticsItemList';
import StatisticsCard from '../statistics-card/StatisticsCard';
import CustomDualAxesChart from '../../../shared/charts/custom-dual-axes-chart/CustomDualAxesChart';
import CustomLineChart from '../../../shared/charts/custom-line-chart/CustomLineChart';
import moment from 'moment';
import { statisticsDataKeys } from '../../analytics/Analytics';
import WidgetWrapper from '../../analytics/WidgetWrapper';

function ServiceRequest(props) {
  const { allStatisticsData, currency, showAllForReport = false } = props;
  const [orderTrend, setOrderTrend] = useState([]);
  const [avgItemsOnOrder, setAvgItemsOnOrder] = useState([]);
  const [mostOrderedItems, setMostOrderedItems] = useState([]);
  const [unpopularItems, setUnpopularItems] = useState([]);
  const [busiestDayOfWeek, setBusiestDayOfWeek] = useState([]);
  const [busiestTimeOfDay, setBusiestTimeOfDay] = useState([]);
  const [popularItems, setPopularItems] = useState([]);

  useEffect(() => {
    const statisticValues = {
      busiestDayOfWeek: setBusiestDayOfWeek,
      busiestTimeOfDay: setBusiestTimeOfDay,
      mostOrderedItems: setMostOrderedItems,
      orderTrend: setOrderTrend,
      unpopularItems: setUnpopularItems,
      avgItemsOnOrder: setAvgItemsOnOrder,
      popularItems: setPopularItems,
    };

    for (const key of Object.keys(statisticValues)) {
      if (allStatisticsData && allStatisticsData[key]) {
        statisticValues[key](allStatisticsData[key]);
      }
    }
  }, [allStatisticsData]);

  return (
    <div className='col-12 d-flex flex-wrap gap-2 wellness-container'>
      {/* Temporarily disable */}
      {/* <div className="col-auto col-sm-12 col-md-auto col-lg-auto">
        <StatisticsCard
          currencyCode={allStatisticsData?.currencyCode}
          data={[
            {
              name: "Requests",
              value: allStatisticsData?.totalOrderCount,
            },
            {
              name: "Transaction",
              value: allStatisticsData?.totalAmount,
            },
          ]}
        />
      </div> */}
      {orderTrend?.length > 0 && (
        <div className='col-auto col-sm-12 col-md col-lg box-shadow custom-card mw-100'>
          <div className='h-100 w-100 mw-100 mh-100'>
            <CustomDualAxesChart
              xAxis={statisticsDataKeys?.date}
              yAxis1={statisticsDataKeys?.requestAmount}
              yAxis2={statisticsDataKeys?.requestCount}
              data={orderTrend?.map((order, index) => {
                return {
                  Date: moment(new Date(order?.date)).format(statisticsDataKeys?.dateFormat),
                  [statisticsDataKeys?.requestAmount]: order?.orderAmount,
                  [statisticsDataKeys?.requestCount]: order?.orderCount,
                };
              })}
              title={'Request Trend'}
              currency={currency}
            />
          </div>
        </div>
      )}
      {avgItemsOnOrder?.length > 0 && (
        <div className='px-2 pt-2 h-100 w-100 mw-100 mh-100'>
          <WidgetWrapper title={'Avg Items On Request'} width='95%' isCustom={true}>
            <CustomLineChart
              title={statisticsDataKeys?.averageItemsPerRequest}
              xAxis={statisticsDataKeys?.date}
              yAxis={statisticsDataKeys?.avgOrderItemsCount}
              data={avgItemsOnOrder?.map((order, index) => {
                return {
                  Date: moment(new Date(order?.date)).format(statisticsDataKeys?.dateFormat),
                  [statisticsDataKeys?.avgRequestItemsCount]: order?.avgOrderItemsCount,
                };
              })}
              includeCard={true}
              tooltipItems={[statisticsDataKeys?.avgRequestItemsCount]}
              additionalData={[
                {
                  name: statisticsDataKeys?.avgItemsPerRequest,
                  value: allStatisticsData?.averageItemsPerRequest,
                },
                {
                  name: statisticsDataKeys?.medianItemsPerRequest,
                  value: allStatisticsData?.medianItemsPerRequest || 0,
                },
              ]}
            />
          </WidgetWrapper>
        </div>
      )}
      <div className='col-12 box-shadow custom-card mw-100 mh-100 d-flex flex-wrap gap-2 p-2'>
        <div className='d-flex col-12 col-md-12 col-lg-12 flex-wrap px-2 mw-100'>
          {popularItems?.length > 0 && (
            <div className='col-12 col-md-6 col-lg-4'>
              <div className='px-2'>
                <StatisticsItemList
                  title='Most Requested Services'
                  key={1}
                  itemListHeight={true}
                  numberField={statisticsDataKeys?.count}
                  columnNames={[statisticsDataKeys?.name, statisticsDataKeys?.count]}
                  items={popularItems?.map((items) => {
                    return {
                      [statisticsDataKeys?.name]: items?.name || '---',
                      [statisticsDataKeys?.count]: items?.count,
                    };
                  })}
                  showAllForReport={showAllForReport}
                  showErrorsList={true}
                />
              </div>
            </div>
          )}
          {popularItems?.length > 0 && (
            <div className='col-12 col-md-6 col-lg-4'>
              <div className='px-2'>
                <StatisticsItemList
                  title='Unpopular Services'
                  key={2}
                  itemListHeight={true}
                  numberField={statisticsDataKeys?.daysSinceLastOrdered}
                  columnNames={[statisticsDataKeys?.name, statisticsDataKeys?.daysSinceLastOrdered]}
                  items={popularItems?.map((items) => {
                    return {
                      [statisticsDataKeys?.name]: items?.name || '---',
                      [statisticsDataKeys?.daysSinceLastOrdered]: items?.daysSinceLastOrdered,
                    };
                  })}
                  showAllForReport={showAllForReport}
                  showErrorsList={true}
                />
              </div>
            </div>
          )}
          <div className='col-12 col-md-12 col-lg-4 d-flex flex-column gap-2'>
            {busiestDayOfWeek?.length > 0 && (
              <div className='col-12 h-50'>
                <CustomColumnChart
                  title={statisticsDataKeys?.busiestDayOfTheWeek}
                  xAxis='Day'
                  yAxis={statisticsDataKeys?.requestCount}
                  data={busiestDayOfWeek?.map((dayData, index) => {
                    return {
                      Day: dayData?.day,
                      [statisticsDataKeys?.requestCount]: dayData?.orderCount,
                    };
                  })}
                />
              </div>
            )}
            {busiestTimeOfDay?.length > 0 && (
              <div className='col-12 h-50'>
                <CustomColumnChart
                  title={statisticsDataKeys?.busiestTimeOfTheDay}
                  xAxis='Time'
                  yAxis={statisticsDataKeys?.requestCount}
                  data={busiestTimeOfDay?.map((timeData, index) => {
                    return {
                      Time: timeData?.time,
                      [statisticsDataKeys?.requestCount]: timeData?.orderCount,
                    };
                  })}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceRequest;
